export default {
  navigation: [
    { name: 'Startseite', href: '/' },
    { name: 'Dienstleistungen', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Über uns', href: '/about' },
    { name: 'Kontakt', href: '/contact' }
  ],
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ],
  contact: {
    phone: '+41 77 218 45 02',
    email: 'info@alpbuild.ch',
    address: 'Schweiz, Kantone Waadt und Genf',
    whatsapp: '+41772184502',
    workingHours: 'Mo-Fr: 7:00-17:00'
  }
};